import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { CornerSolutionComponent } from '@inter-ikea-storageone/range';
import CornerAddonFrameComponent from '../api/components/CornerAddonFrameComponent';
import CornerRegularFrameComponent from '../api/components/CornerRegularFrameComponent';
import { ProductType } from '@inter-ikea-storageone/range';
/**
 * Handles can only be added to one of the doors of a corner solution.
 * This should be on the door on the regular frame except if that door
 * is 25cm wide, then it should be on the door on the corner frame.
 */
export const doorOnCornerSolutionCanHaveHandles = (door, coreApi) => {
    const cornerSolution = HierarchyUtils.findInUpwardsHierarchy(door, entity => entity.hasComponent(CornerSolutionComponent.id));
    const cornerRegularFrame = cornerSolution &&
        HierarchyUtils.findInHierarchy(cornerSolution, entity => entity.hasComponent(CornerRegularFrameComponent.id));
    const cornerAddonFrame = cornerSolution &&
        HierarchyUtils.findInHierarchy(cornerSolution, entity => entity.hasComponent(CornerAddonFrameComponent.id));
    const hostFrame = HierarchyUtils.findInUpwardsHierarchy(door, entity => entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
    if (hostFrame &&
        doorOnRegularFrameIs25(cornerRegularFrame, cornerAddonFrame, coreApi) &&
        coreApi.entities.isProductType(hostFrame, ProductType.PAX_FRAME)) {
        return false;
    }
    else if (hostFrame &&
        !doorOnRegularFrameIs25(cornerRegularFrame, cornerAddonFrame, coreApi) &&
        coreApi.entities.isProductType(hostFrame, ProductType.PAX_ADD_ON_CORNER_FRAME)) {
        return false;
    }
    return true;
};
const doorOnRegularFrameIs25 = (regularFrame, addonFrame, coreApi) => {
    const regularFrameWidth = regularFrame && coreApi.entities.getEntityComSize(regularFrame)?.width;
    const addonFrameDepth = addonFrame && coreApi.entities.getEntityComSize(addonFrame)?.depth;
    return addonFrameDepth === 580.0 && regularFrameWidth === 750.0;
};
export const isCornerFrameAllowingDoors = (coreApi, cornerSolution) => {
    const cornerRegularFrame = HierarchyUtils.findInHierarchy(cornerSolution, entity => entity.hasComponent(CornerRegularFrameComponent.id));
    const cornerAddonFrame = HierarchyUtils.findInHierarchy(cornerSolution, entity => entity.hasComponent(CornerAddonFrameComponent.id));
    const addonFrameDepth = cornerAddonFrame && coreApi.entities.getEntityComSize(cornerAddonFrame)?.depth;
    const baseFrameWidth = cornerRegularFrame && coreApi.entities.getEntityComSize(cornerRegularFrame)?.width;
    return ((addonFrameDepth === 580.0 && baseFrameWidth === 1000.0) ||
        (addonFrameDepth === 580.0 && baseFrameWidth === 750.0) ||
        (addonFrameDepth === 350.0 && baseFrameWidth === 750.0) ||
        (addonFrameDepth === 350.0 && baseFrameWidth === 500.0));
};
//# sourceMappingURL=cornerSolution.js.map